import { render, staticRenderFns } from "./AdministrativeList.vue?vue&type=template&id=3cc9906d&scoped=true&"
import script from "./AdministrativeList.vue?vue&type=script&lang=js&"
export * from "./AdministrativeList.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeList.vue?vue&type=style&index=0&id=3cc9906d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9906d",
  null
  
)

export default component.exports